// src/lib/text.js
import { formatNumber } from "../helpers/utils";

export function flattenAIDecisions(decisions, max = 6) {
  const arr = [
    ...(decisions?.mission_critical || []),
    ...(decisions?.this_week || []),
    ...(decisions?.next_week || []),
  ].filter(Boolean);
  return arr.slice(0, max);
}

export function assembleReportText(report, aiExecSummary, decisions) {
  const lines = [];
  lines.push("Executive Summary");
  lines.push(aiExecSummary?.trim() || "");
  lines.push("");
  lines.push("KPIs");
  lines.push(`• Issues closed: ${report.kpis.issuesClosed}`);
  lines.push(`• Lead time: ${report.kpis.leadTimeDays.toFixed(1)} days`);
  lines.push(`• On-time releases: ${Math.round(report.kpis.onTimePct)}%`);
  lines.push(`• On-time tasks: ${Math.round(report.kpis.onTimeTasksPct)}%`);
  lines.push("");
  lines.push("Risks & Owners");
  if (!report.risks?.length) {
    lines.push("• None above thresholds");
  } else {
    report.risks.forEach((r) => {
      lines.push(
        `• ${r.title} — Owner: ${r.owner} — ${r.ageDays}d old${
          r.cost ? ` — $${formatNumber(r.cost)}` : ""
        }`
      );
    });
  }
  lines.push("");
  lines.push("Decisions Needed");
  const aiDecs = flattenAIDecisions(decisions);
  if (aiDecs.length) aiDecs.forEach((d) => lines.push(`• ${d}`));
  else lines.push("• None");
  return lines.join("\n");
}
export default assembleReportText